import React from 'react'
import WhoWeAre from "../../WhoWeAre/WhoWeAre";
const WhoWeArePDF = () => {
  return (
    <div className ="px-20 flex justify-center   " style={{ height: "100vh",transform:"scale(1.05)",}}>
    <div className="pt-24">
    <WhoWeAre whoweare="pdf"  />
    </div>
          </div>
  )
}

export default WhoWeArePDF